import { render, staticRenderFns } from "./pentestEdit.vue?vue&type=template&id=271f0875"
import script from "./pentestEdit.vue?vue&type=script&lang=js"
export * from "./pentestEdit.vue?vue&type=script&lang=js"
import style0 from "./pentestEdit.vue?vue&type=style&index=0&id=271f0875&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports